<template>
  <div class="background-03">
    <v-layout row wrap justify-center pt-5>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Flujo positivo y negativo'" videoEmbed="ADMINISTRACIONDINERO14FlujoPositivoNegativo (ant45).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm3 text-xs-right class="hidden-xs-only" mt-2 hidden-xs-only>
        <image-app class="animated fadeInLeft" :imaSize="120" imaSrc="design/red-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm8 class="animated fadeInUp dura_1" mt-2>
        <h1 aria-hidden>
          <span aria-hidden="true" class="font-red">Los ingresos (entradas) y los egresos (salidas)</span><br>
          <span aria-hidden="true">
          de dinero forman un flujo de efectivo. 
          La diferencia entre las entradas y salidas determina si se cuenta con el flujo<br>
          </span>
          <span aria-hidden="true" class="davi-curs">de efectivo positivo (+) o negativo (-).</span>
        </h1>
        <p class="offscreen">Los ingresos (entradas) y los egresos (salidas) de dinero forman el flujo de efectivo. La diferencia entre las entradas y salidas determina si se cuenta con el flujo de efectivo positivo (+) o negativo (-).</p>
        <v-flex xs12 sm12 text-xs-center mt-2  hidden-xs-only>
          <image-app class="animated fadeInLeft" :imaSize="386" imaSrc="design/texture" imaAlt=""></image-app>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>
<style lang="scss" scoped>
h1{
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// davivienda-14.vue?0286f821